import { ref, onMounted, onUnmounted } from 'vue'

export function useInViewport(selector: string): { isInViewport: Ref<boolean> } {
  const isInViewport = ref(false)

  const checkInViewport = () => {
    const el = document.querySelector<HTMLElement>(selector)
    if (!el) {
      isInViewport.value = false
      return
    }

    const rect = el.getBoundingClientRect()

    // Check if the element is partially in the viewport
    isInViewport.value =
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right > 0
  }

  onMounted(() => {
    checkInViewport() // Initial check
    window.addEventListener('scroll', checkInViewport)
    window.addEventListener('resize', checkInViewport)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', checkInViewport)
    window.removeEventListener('resize', checkInViewport)
  })

  return { isInViewport }
}
